import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import moment from 'moment';
import { browserHistory } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import Header from '../../components/Header';
import {
  convertServerDateToTeamZone,
  getTeamData,
  getTerritoryData,
  getUser,
  onGoBack
} from '../../common/globals';
import { getSetProductContents } from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import withOnline from '../../common/withOnline';
import ArrowRightIcon from '../../assets/images/arrow-right-bold-outline-custom.png';
import withSetsToMove from '../../common/withSetsToMove.js';
import SetsContentModal from '../../components/Models/SetsContentModal';

class SetsContents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'Set Status',
      subPageTitle: 'Set Contents',
      setsContents: [],
      setsStatus: [],
      showSetStatus: true,
      setsContentModalData: [],
      setsContentsCount: 0,
    };
    this.SetsContentModalModal = null;
  }

  componentDidMount() {
    try {
      this.SetsContentModalModal = new window.bootstrap.Modal(window.$('#SetsContentModalModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSetProducts = (id) => {
    try {
      const { notify, setLoader, online } = this.props;
      const productData = {};
      if (online) {
        setLoader(true);
        getSetProductContents({ set_name: id }).then((response) => {
          const {
            status, data, locations, server_timezone
          } = response;
          if (status) {
            setLoader(false);
            let countProductQty = 0;
            if (data) {
              data.map((item) => {
                if (!productData.hasOwnProperty(item.TrayName)) {
                  productData[item.TrayName] = [];
                }
                productData[item.TrayName].push(item);

                countProductQty = Number(item.Qty) + Number(countProductQty);
              });
            }
            if (typeof locations !== 'undefined' && locations !== null) {
              const locationsWithLocalTime = locations.map((location) => ({
                ...location,
                MoveDate: convertServerDateToTeamZone(location.MoveDate, server_timezone)
              }));

              this.setState({
                setsContents: productData,
                setsStatus: locationsWithLocalTime,
                setsContentsCount: countProductQty
              });
            } else {
              this.setState({
                setsContents: productData,
                setsContentsCount: countProductQty
              });
            }
          } else {
            setLoader(false);
            notify({ type: 'error', message: response.message });
          }
        });
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetContentBack = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _changeDataView = () => {
    try {
      const { showSetStatus, title, subPageTitle } = this.state;
      this.setState({
        showSetStatus: !showSetStatus,
        title: subPageTitle,
        subPageTitle: title
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMoveSet = (setToMove) => {
    const {
      online, notify, setSetsToMove, goBack, setGoBack
    } = this.props;
    if (!online) {
      notify({ type: 'error', message: 'You must have an internet connection. Please check you connection and try again.', time: 5 });
      return;
    }
    setSetsToMove([setToMove]);
    setGoBack([...goBack, window.location.pathname]);

    const currentDate = moment();
    if (moment(setToMove.NextDate).isAfter(currentDate)) {
      this.setState({ setsContentModalData: setToMove });
      this.SetsContentModalModal.show();
    } else {
      browserHistory.push('/move-sets-to-location');
    }
  }

  _onSaveSetContentModal = () => {
    this.SetsContentModalModal.hide();
    browserHistory.push('/move-sets-to-location');
  }

  _onRemoveSetContentModal = () => {
    this.SetsContentModalModal.hide();
  };

  UNSAFE_componentWillMount() {
    try {
      const { params, online, notify } = this.props;
      if (params.hasOwnProperty('id')) {
        if (online) {
          this._getSetProducts(params.id);
        } else {
          notify({ type: 'error', message: 'You must have an internet connection. Please check you connection and try again.', time: 5 });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      goBack, params: { id }
    } = this.props;
    const {
      setsContents, setsStatus, showSetStatus, title, subPageTitle, setsContentsCount
    } = this.state;
    const user = getUser();

    return (
      <section className="list-section resizer-class">
        <Header
          title={title}
          goBack={() => onGoBack(goBack)}
          actionButton={{ title: subPageTitle.substring(4), onClick: this._changeDataView }}
        />
        <section className="sets-section">
          <div className="container resizer-class">
            <div className="top-block pb-0">
              <div className="row" style={{ borderBottom: '1px solid white', marginBottom: 10, paddingBottom: 10 }}>
                <div className="col">
                  <h2 className="sets-title setsBlock">
                    <span>
                      {id}
                    </span>
                    {
                      showSetStatus
                        ? ''
                        : (
                          <span style={{ 'text-align': 'center' }}>
                            Qty: {setsContentsCount > 0 ? setsContentsCount : ''}
                          </span>
                        )
                    }
                  </h2>
                </div>
              </div>
            </div>
            {showSetStatus ? (
              <div className="sets-list-blocks t-b-border-0 p-0">
                {setsStatus && Object.keys(setsStatus).length > 0 && (
                  <div className="contents-wrap">
                    <div className="row gx-3">
                      <div style={{ width: 40 }}>
                        <p>Set</p>
                      </div>
                      <div className="col">
                        <p>Location</p>
                      </div>
                      <div className="col-auto" />
                    </div>
                  </div>
                )}
                {setsStatus && Object.keys(setsStatus).length > 0
                  ? Object.keys(setsStatus.sort((a, b) => {
                    if (a.SetNo < b.SetNo) return -1;
                    if (a.SetNo > b.SetNo) return 1;
                    return 0;
                  })).map((item, index) => (
                    <div className="sets-block" key={index + 1}>
                      <div
                        className="row gx-3 cursor-pointer"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index + 1}`}
                      >
                        <div style={{ width: 40 }}>
                          <p>{setsStatus[item].SetNo}</p>
                        </div>
                        <div className="col">
                          <p>{setsStatus[item].LocName}</p>
                        </div>
                        <div
                          className="col-auto btn-collapse collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index + 1}`}
                          aria-expanded="false"
                        >
                          <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                        </div>
                      </div>
                      <div className="collapse" id={`collapse${index + 1}`}>
                        <div
                          className="bg-card"
                          style={{
                            width: '100%',
                            marginBottom: 2,
                            backgroundColor: '#424242',
                            position: 'relative',
                            padding: 10
                          }}
                        >
                          <table>
                            <tbody>
                              <tr>
                                <td width={100}>Status: </td>
                                <td>{setsStatus[item].SetStatus}</td>
                              </tr>
                              <tr>
                                <td>Moved By: </td>
                                <td>{setsStatus[item].MoveUser}</td>
                              </tr>
                              <tr>
                                <td>Moved At: </td>
                                <td>{setsStatus[item].MoveDate ? moment(setsStatus[item].MoveDate)
                                  .format('MM/DD/YYYY hh:mm A') : null}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {
                            getTerritoryData(user).isSetMove && getTeamData(user).isSetMove ? (
                              <a
                                role="button"
                                tabIndex={0}
                                style={{
                                  position: 'absolute',
                                  right: 10,
                                  top: '50%',
                                  transform: 'translateY(-50%)'
                                }}
                                onClick={() => this._onMoveSet(setsStatus[item])}
                              >
                                <img className="optimize-icon" src={ArrowRightIcon} alt="arrow-right" />
                              </a>
                            ) : null
                          }
                        </div>
                        <div
                          className="bg-card"
                          style={{
                            width: '100%',
                            marginBottom: 2,
                            backgroundColor: '#424242',
                            padding: 10
                          }}
                        >
                          <table>
                            <tbody>
                              <tr>
                                <td width={100}>Prev Case: </td>
                                <td>{setsStatus[item].PrevCase}</td>
                              </tr>
                              <tr>
                                <td>Prev Date: </td>
                                <td>{setsStatus[item].PrevDate && moment(setsStatus[item].PrevDate).format('L')}</td>
                              </tr>
                              <tr>
                                <td>Prev Loc: </td>
                                <td>{setsStatus[item].PrevLocName}</td>
                              </tr>
                              <tr>
                                <td>Prev Rep: </td>
                                <td>{setsStatus[item].PrevRep}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="bg-card"
                          style={{
                            width: '100%',
                            backgroundColor: '#424242',
                            marginBottom: 2,
                            padding: 10
                          }}
                        >
                          <table>
                            <tbody>
                              <tr>
                                <td width={100}>Next Case: </td>
                                <td>{setsStatus[item].NextCase}</td>
                              </tr>
                              <tr>
                                <td>Next Date: </td>
                                <td>{setsStatus[item].NextDate && moment(setsStatus[item].NextDate).format('L')}</td>
                              </tr>
                              <tr>
                                <td>Next Loc: </td>
                                <td>{setsStatus[item].NextLocName}</td>
                              </tr>
                              <tr>
                                <td>Next Rep: </td>
                                <td>{setsStatus[item].NextRep}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {setsStatus[item].MissingProducts?.length > 0 && (
                          <>
                            <div
                              className="bg-card"
                              style={{
                                width: '100%',
                                backgroundColor: '#424242',
                                padding: 10
                              }}
                            >
                              <table>
                                <tbody>
                                  <tr>
                                    <td>Missing:</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              className="bg-card"
                              style={{
                                width: '100%',
                                backgroundColor: '#424242',
                                marginBottom: 10,
                              }}
                            >
                              {setsStatus[item].MissingProducts?.split(';').map((product) => {
                                const info = product.split(',');
                                const prodId = info[0];
                                const prodName = info[1];
                                const qty = info[2];

                                return (
                                  <div
                                    key={prodId}
                                    className="bg-card"
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      borderBottom: '1px solid #AFAFAF',
                                      paddingLeft: 10,
                                      paddingRight: 10,
                                      paddingTop: 8,
                                      paddingBottom: 8,
                                    }}
                                  >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                      <span>{prodId}</span>
                                      <span>{prodName}</span>
                                    </div>
                                    <div style={{ textAlign: 'left', minWidth: 60 }}>
                                      Qty: {qty}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )) : (
                    <div className="sets-block">
                      <h5>Set status are not loaded for this set.</h5>
                    </div>
                  )}
              </div>
            ) : (
              <div className="sets-list-blocks t-b-border-0 p-0">
                <div className="sets-block">
                  {
                    Object.keys(setsContents).length > 0
                      ? Object.keys(setsContents).map((value, index) => (
                        <div className="sets-block" key={index}>
                          {
                            (value !== '' && value !== 'null') && (
                              <h4 className="setsBlock">
                                <span>
                                  {
                                    (value === '' || value === null || value === 'null') ? '' : value
                                  }
                                </span>
                                <span style={{ 'text-align': 'right' }}>Tray Qty: {
                                  setsContents[value].reduce(
                                    (total, currentValue) => (total + +currentValue.Qty), 0
                                  )
                                }
                                </span>
                              </h4>
                            )
                          }
                          <ul className="list-unstyled">
                            {
                              setsContents[value].map((data, key) => (
                                <li className="pt-2 pb-2" key={key}>
                                  <div className="contents-wrap">
                                    <div className="row gx-2">
                                      <div className="col">
                                        <p>{data.ProductNo}</p>
                                        <p>{data.ProductDescription}</p>
                                      </div>
                                      <div className="col-auto">
                                        <span>Qty: </span>{data.Qty}
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))
                            }
                          </ul>
                        </div>
                      )) : (
                        <div className="sets-block">
                          <h5>Set contents are not loaded for this set.</h5>
                        </div>
                      )
                  }
                </div>
              </div>
            )}
          </div>
        </section>

        <SetsContentModal
          onSave={this._onSaveSetContentModal}
          setsContentData={this.state.setsContentModalData}
          onCanel={this._onRemoveSetContentModal}
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'SetInfoForm',
});

export default withSetsToMove(
  withOnline(
    withGoBack(
      withForm(
        withNotify(
          withLoader(
            SetsContents
          )
        )
      )
    )
  )
);
